import React, { useEffect, useState } from "react";
import Get from "../services/Get";
import {
  Button,
  Card,
  Col,
  Row,
  Skeleton,
  Space,
  Spin,
  Typography,
} from "antd";
import Meta from "antd/lib/card/Meta";
import { CarFilled, DotChartOutlined } from "@ant-design/icons";
import Post from "../services/Post";
import TwoWheeler from "../assets/images/two-wheeler.png";
import { useNavigate } from "react-router-dom";

const GetQR = () => {
  const [vehicle, setVehicle] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  const getVehicle = async () => {
    setLoading(true);
    try {
      await Get.MyVehicle().then((res) => {
        console.log("vehicle", res.data);
        setVehicle(res.data);
      });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const nextPage = (data) => {
    setLoading(true);
    console.log("data.id", data.id);

    Post.getQr({ id: data.id })
      .then((res) => {
        console.log("reached here");
        console.log("qr code", res);

        setLoading(false); // Ensure loading is stopped before navigation
        navigate("/user/fetch-qr", {
          state: {
            data: res.status === 400 ? data : res,
            isNew: res.status === 400,
          },
        });
      })
      .catch((error) => {
        console.error("Error fetching QR code:", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    getVehicle();
  }, []);

  return (
    <div className="layout-content">
      {loading ? (
        <Row className="mb-4" justify={"center"} gutter={[16, 24]}>
          {["", "", "", "", "", "", "", "", "", "", "", ""].map((Item) => (
            <Col xs={6} style={{ justifyContent: "center" }}>
              <Skeleton.Node
                active={true}
                style={{
                  width: 340,
                  height: 240,
                }}
              >
                <DotChartOutlined
                  style={{
                    display: "none",
                  }}
                />
              </Skeleton.Node>
            </Col>
          ))}
        </Row>
      ) : vehicle.length > 0 ? (
        <>
          <Row className="mb-4" justify={"center"} gutter={[16, 24]}>
            {vehicle.map((Item) => (
              <Col xl={6} xs={24} md={12} style={{ justifyContent: "center" }}>
                <Card
                  hoverable
                  // style={{
                  //     width: 240,
                  // }}
                  // cover={<img alt="example" src="https://os.alipayobjects.com/rmsportal/QBnOOoLaAfKPirc.png" />}
                  cover={
                    Item.vehicle_seat_capacity > 2 ? (
                      <CarFilled
                        style={{ fontSize: "150px", padding: "40px 0" }}
                      />
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          padding: "40px 0",
                        }}
                      >
                        <img
                          style={{ width: "150px" }}
                          src={TwoWheeler}
                          alt="Two Wheeler"
                        />
                      </div>
                    )
                  }
                  onClick={() => nextPage(Item)}
                >
                  <Meta title={Item?.model} description={Item?.reg_no} />
                </Card>
              </Col>
            ))}
          </Row>
          <Row justify={'center'} className="mt-4">
            <Button
              type="primary"
              size="large"
              style={styles.button}
              onClick={() => navigate("/user/add-vehicle")}
            >
              Add Vehicle
            </Button>
          </Row>
        </>
      ) : (
        <Row justify="center" align="middle">
          <Col xs={22} sm={18} md={14} lg={10} xl={8}>
            <div style={styles.content}>
              <Typography.Title level={2} style={styles.title}>
                You have no vehicle!
              </Typography.Title>
              <Space style={styles.buttonGroup}>
                <Button
                  type="primary"
                  size="large"
                  style={styles.button}
                  onClick={() => navigate("/user/add-vehicle")}
                >
                  Add Vehicle
                </Button>
              </Space>
            </div>
          </Col>
        </Row>
      )}
    </div>
  );
};

const styles = {
  content: {
    backgroundColor: "#ffffff",
    padding: "40px 20px",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    textAlign: "center",
  },
  title: {
    marginBottom: "16px",
    color: "#333",
  },
  buttonGroup: {
    marginTop: "16px",
  },
  button: {
    width: "150px",
    backgroundColor: "#a6cc43",
    borderColor: "#a6cc43",
  },
};

export default GetQR;
